module.exports = __webpack_public_path__ + "img/example_sign_row.972df5ac.svg";